module.exports = __webpack_public_path__ + "fonts/unicons.d455f121.ttf";